<template>
  <liste-documents
    :categorie="categorie"
    :title="$t('menu.documents.consultationGynecologique')"
  />
</template>

<script>
export default {
  props: {
    categorie: {
      type: String,
    },
  },
}
</script>
